module.exports = __webpack_public_path__ + "static/favicon-8bf0ec37e82ffabaf4a44ca39f56ad24.ico";